import axios from "axios";
// const url = "http://192.168.100.150:7070/api/";
const url = "https://wincliniclabbackend.kwintechnologies.com/api/";
// const url = "http://localhost:9000/api/";
// const CRMURL = "http://crmbackend.kwintechnologies.com:3500/api/";
const storeToken = localStorage.getItem("token");

const apiInstance = axios.create({
  baseURL: url,
  // headers: {
  //   Authorization: `Bearer ${storeToken}`
  // }
});

apiInstance.interceptors.request.use(
  (config) => {
    if (storeToken) {
      config.headers["Authorization"] = `Bearer ${storeToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiInstance;
